import axios from 'axios';

const baseURL = 'https://viacep.com.br/ws/';

export const addressApi = axios.create({
  baseURL,
});
